import React from 'react'
import { Button, Form, ModalBody, ModalFooter } from 'reactstrap'

export const DeletePrinterPoint = ({toggle, loading, name, saveDelete}) => {
    return (
        <Form className="theme-form" role="form" onSubmit={saveDelete}>
            <ModalBody>
                <p className="h6 txt-danger">Estas a punto de eliminar el siguiente punto de impresión:</p>                
                <b>{ name}</b>
                <br />
                <p>¿Estás seguro de hacerlo?</p>
            </ModalBody>
            <ModalFooter>
                <Button
                    size="sm"
                    color="primary"
                    type="submit"
                    className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                >
                    Si,eliminar punto de impresión
                </Button>    
                <Button size="sm" className="btn-air-light" color="light" type="button" onClick={toggle}>Cancelar</Button>            
            </ModalFooter>
        </Form>
    )
}
